<template>
  <modal
    v-slot="{ data: { order, unavailableItems } }"
    name="reorder"
    modal-style="compact"
    :is-required="true"
  >
    <reorder-items
      :order="order"
      :unavailable-items="unavailableItems"
    />
  </modal>
</template>


<script>
  import ReorderItems from './reorder-items/index.vue';


  export default {
    name: 'ReorderItemsModal',

    components: {
      ReorderItems
    }
  };
</script>
